
import React, { useMemo, useEffect } from "react";
import useContentCompiler from "../../../react-hooks/useContentCompiler"
import { findBTLeftNav, initLeftNav, clearLeftNav } from "./utils"
import { withPrefix } from "gatsby";
import {useApplicationContext} from '../../../provider'


export default function LeftNavigation ({ location, leftNav }) {
  const pathname = withPrefix('/') !== '/' ? '/'+location.pathname.split('/').slice(2).join('/') : location.pathname
  const currentNav = useMemo(() => {
     return findBTLeftNav(leftNav, pathname)
   }, [ pathname ])
  const { handleBarCompiler } = useApplicationContext() ; 
  const rawTemplate = require(`raw-loader!../../../compiled/braintree/templates/partials/sidebar.hbs`)
  const { content, loaded } = useContentCompiler(rawTemplate, handleBarCompiler, {sidenav: currentNav, ifNotHidden:true , currentPath:location.pathname,
    "isArticles":false,"sub_menu":false, "external_link":true})
    
    useEffect(() => {
      if(!loaded) return;
      initLeftNav(pathname)
      return () => clearLeftNav()
    }, [pathname, loaded])

    return (
      loaded ? <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: content}} /> : null
    );
};
